import axios from "../libs/axios";
import authHeader from "./auth-header";

const API_URL = `${process.env.VUE_APP_API_ENDPOINT}/v1`;

class AllocationAreaService {
  find(params) {
    return axios.get(`${API_URL}/allocation-areas`, {
      headers: authHeader(),
      params,
    });
  }

  findByAllocationID(allocation_id) {
    return axios.get(`${API_URL}/allocation-areas/${allocation_id}`, {
      headers: authHeader(),
    });
  }

  create(data) {
    return axios.post(`${API_URL}/allocation-area`, data, {
      headers: authHeader(),
    });
  }
  findByID(id) {
    return axios.get(`${API_URL}/allocation-area/${id}`, {
      headers: authHeader(),
    });
  }

  update(data) {
    const _id = data._id;
    return axios.put(`${API_URL}/allocation-area/${_id}`, data, {
      headers: authHeader(),
    });
  }

  delete(id) {
    console.log("delete", id);
    return axios.delete(`${API_URL}/allocation-area/${id}`, {
      headers: authHeader(),
    });
  }
}

export default new AllocationAreaService();
